import { Link } from "react-router-dom";

const footerLinks = {
  services: {
    title: "服务",
    links: [
      { label: "网站开发", href: "#services" },
      { label: "移动应用", href: "#services" },
      { label: "云计算", href: "#services" },
      { label: "网络安全", href: "#services" },
    ],
  },
  company: {
    title: "公司",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "案例展示", href: "#projects" },
      { label: "客户评价", href: "#testimonials" },
      { label: "加入我们", href: "#cta" },
    ],
  },
  contact: {
    title: "联系方式",
    items: [
      { icon: "ri-phone-line", label: "400-888-9999" },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="relative bg-[#1a2a1e] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-background-50 font-heading font-bold text-base">天</span>
              </div>
              <span className="font-heading font-bold text-xl tracking-tight text-white">
                Tianyi
              </span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              用技术驱动商业新未来。Tianyi 致力于为企业提供全方位的数字化解决方案。
            </p>
          </div>

          <div>
            <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-5">
              {footerLinks.services.title}
            </p>
            <div className="flex flex-col gap-3">
              {footerLinks.services.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/60 hover:text-white text-sm transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-5">
              {footerLinks.company.title}
            </p>
            <div className="flex flex-col gap-3">
              {footerLinks.company.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/60 hover:text-white text-sm transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-5">
              {footerLinks.contact.title}
            </p>
            <div className="flex flex-col gap-3">
              {footerLinks.contact.items.map((item) => (
                <div key={item.label} className="flex items-center gap-2 text-white/60 text-sm">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${item.icon} text-xs`}></i>
                  </span>
                  {item.label}
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-linkedin-box-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="relative mb-10">
          <h3 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white/6 tracking-tight select-none">
            TIANYI
          </h3>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6 border-t border-white/10">
          <p className="text-white/30 text-xs order-2 sm:order-1">
            &copy; {new Date().getFullYear()} Tianyi Network Technology. All rights reserved.
          </p>
          <div className="flex items-center gap-4 order-1 sm:order-2">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-white/30 hover:text-white/60 text-xs transition-colors duration-200"
            >
              粤ICP备2022043961号-5
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}